import { render, staticRenderFns } from "./TalkCard.vue?vue&type=template&id=e829703a&scoped=true&"
import script from "./TalkCard.vue?vue&type=script&lang=js&"
export * from "./TalkCard.vue?vue&type=script&lang=js&"
import style0 from "./TalkCard.vue?vue&type=style&index=0&id=e829703a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e829703a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VIcon})
